import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'

import { I577Form } from 'clickNgo/models/crud/forms'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IPartnerFlag } from '../../models'

import { mapPartnerFlagFrom577Crud } from './mapping'

type Params = {
  partnerId: string
  partnerFlag: Pick<IPartnerFlag, 'code' | 'codeName'>
}

export const checkForInactivePartnerFlags = (params: Params, options?: ICrudFetchOptions) => {
  const source = CrudStore.get(CrudStoreItemScout.WW_PartnerFlags_Inactive, options?.cacheKey)

  const filterByPartnerId = {
    field: 'PARTNER_ID',
    operator: Operator.EQUAL,
    value: params.partnerId,
  }

  const filterByCodeName = {
    field: 'CodeName',
    operator: Operator.EQUAL,
    value: params.partnerFlag.codeName || '',
  }

  const filterByCode = {
    field: 'Code',
    operator: Operator.EQUAL,
    value: params.partnerFlag.code || '',
  }

  source.setFilter({
    logic: Logic.AND,
    filters: [
      filterByPartnerId,
      {
        logic: Logic.OR,
        filters: [filterByCodeName, filterByCode],
      },
    ],
  })

  return source
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result: { items: I577Form[] }) => {
      if (result && result.items) {
        return result.items.map(mapPartnerFlagFrom577Crud)
      }

      return []
    })
    .catch((e: string) => {
      Logger.error(e)
      return []
    })
}
